export const columnActionType = { show: 'column@show' };

export const showColumns = columns => ({
  type: columnActionType.show,
  columns,
});
